import React, { useState, useRef } from "react";
import "../../../Enterprise/EntertrpriseComponents/EnterpriseCaseStudyComponents/EnterpriseCaseStudy.css";
import "../../../Common Components/Hero.css";
import CaseStudyIndividualPage from "../../../assets/images/CaseStudyIndividualPage.jpg";
import TataCommunicationsCaseStudy from "../../../assets/pdf/TataCommunicationsCaseStudy.pdf";
import ProductsLinked from "../../../Common Components/ProductsLinked";

const TataCommunications = () => {
  const products = [
    { id: 1, name: 'Inesh' },
  ];

  const [showPopup, setShowPopup] = useState(false);
  const [showDownloadPopup, setShowDownloadPopup] = useState(false);
  const emailInputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userEmail = emailInputRef.current.value;

    const formId = "1FAIpQLScCh_Wn_mi8GlNCFJg0xw82iFGq9m3a7Z2STUBKRA2sSh9TKQ";
    const emailEntryId = "entry.1870394174";
    const nameEntryId = "entry.1812720550";
    const phoneEntryId = "entry.97349512";
    const messageEntryId = "entry.231532781";

    // Construct the form submission URL with the email and other fields filled with custom messages
    const formUrl = `https://docs.google.com/forms/d/e/${formId}/formResponse?${emailEntryId}=${encodeURIComponent(
      userEmail
    )}&${nameEntryId}=TataCommunications&${phoneEntryId}=TataCommunications%20case%20study%20downloaded&${messageEntryId}=TataCommunications%20case%20study%20downloaded`;

    try {
      // Submit the form data using Fetch API
      await fetch(formUrl, {
        method: "POST",
        mode: "no-cors",
      });

      // Show the download button upon successful submission
      setShowPopup(false);
      setShowDownloadPopup(true);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setShowDownloadPopup(false);
  };

  const handleDownloadPDF = () => {
    const link = document.createElement("a");
    link.href = TataCommunicationsCaseStudy;
    link.setAttribute("download", "Tata Communications Case Study.pdf");
    link.click();
  };

  const handleOpenPopup = () => {
    setShowPopup(true);
    setShowDownloadPopup(false);
  };

  return (
    <div className="Individual-CaseStudy-Div">
      <div
        className="ImageBackgroundWrap Background-fixed"
        style={{
          backgroundImage: `url(${CaseStudyIndividualPage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="ImageInnerWrap"></div>
      </div>

      <div className="headline" id="CaseStudyDv">
        <h1>TATA COMMUNICATIONS</h1>
      </div>

      <div className="case-study-div">
        <div className="case-study">
          <div className="case-study-table">
            <table>
              <tbody>
                <tr>
                  <td className="table-label">Assignment name:</td>
                  <td>Smart Energy Meter for AMR</td>
                </tr>
                <tr>
                  <td className="table-label">
                    Approx. value of the contract:
                  </td>
                  <td> INR 5,00,000</td>
                </tr>
                <tr>
                  <td className="table-label">Country:</td>
                  <td>India</td>
                </tr>
                <tr>
                  <td className="table-label">Location within country:</td>
                  <td>Noida, Mohali and Gaziabad</td>
                </tr>
                <tr>
                  <td className="table-label">
                    Duration of assignment (months):
                  </td>
                  <td>1</td>
                </tr>
                <tr>
                  <td className="table-label">
                    Total No of staff-months of the assignment:
                  </td>
                  <td>2</td>
                </tr>
                <tr>
                  <td className="table-label">
                    Name of senior professional staff of your firm involved and
                    functions performed:
                  </td>
                  <td>
                    Mr. Abhijeet Ghosh – Senior Technical Consultant Mr.
                    Abhishek Trivedi – Lead Technical Consultant
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <button className="read-more-btn" onClick={handleOpenPopup}>
            Read More
          </button>
          {showPopup && (
            <div className="popup">
              <button className="close-btn" onClick={handleClosePopup}>
                Close
              </button>
              <p className="popup-message">
                Want to read more of this case study? Please give us your email:
              </p>
              <form onSubmit={handleSubmit} className="email-form">
                <input
                  type="email"
                  ref={emailInputRef}
                  name="email"
                  placeholder="Enter your email"
                  required
                />
                <button type="submit">Submit</button>
              </form>
            </div>
          )}
          {showDownloadPopup && (
            <div className="popup">
              <button className="close-btn" onClick={handleClosePopup}>
                Close
              </button>
              <p>
                Thank you for your email. Your case study PDF is ready for
                download:
              </p>
              <div className="download-button-container">
                <button className="download-btn" onClick={handleDownloadPDF}>
                  Download PDF
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <ProductsLinked products={products} />
    </div>
  );
};

export default TataCommunications;
